export function enumToValueArr(enumType: any) {
    return Object.keys(enumType).map(k => enumType[k]);
}
